import React from "react";

function LanguageSelector({ setLanguage }) {
  return (
    <div className="language-selector">
      <label>Select Language: </label>
      <select onChange={(e) => setLanguage(e.target.value)}>
        <option value="en">English</option>
        <option value="hi">Hindi</option>
        <option value="te">Telugu</option>
        <option value="ta">Tamil</option>
        <option value="es">Spanish</option>
      </select>
    </div>
  );
}

export default LanguageSelector;
